import React from "react";
import { Stack, Box, Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";
import FrameCard from "../../shared/FrameCard";
import HeaderSection from "../HeaderSection/HeaderSection";
import SectionTitle from "../../shared/SectionTitle";
import NoticeBanner from "../../shared/NoticeBanner";
import ActionButton from "../../shared/ActionButton";
import SkillCategory from "./SkillCategory";
import { editSkillSheetSelfEvaluationsPathFor } from "../../utils/skillSheetRouting";
import { useIsDesktop } from "../../shared/hooks/useIsDesktop";
import {
  PROJECT_COLOR,
  PROJECT_COLOR_DARK,
  GRAY_COLOR,
} from "../../../constants/colors";

/**
 * スキルセクション
 */
const SkillSection = ({ skill, showEditButton, owner }) => {
  const isDesktop = useIsDesktop();
  const categories = skill?.skillCategories ?? [];

  const navigate = useNavigate();

  // 自己評価編集へ遷移
  const onEditClick = () => {
    navigate(editSkillSheetSelfEvaluationsPathFor(owner));
  };

  // items が1件でも入っているカテゴリがあるか
  const isEmpty = categories.every(
    (category) => (category.skillGroups ?? []).length === 0,
  );

  return (
    <FrameCard>
      <Stack spacing={2}>
        <HeaderSection
          title={<SectionTitle title="スキル" />}
          notice={
            showEditButton ? (
              <NoticeBanner
                text={
                  "実力を見える化することで、\n強みをビジュアルで表示します。"
                }
              />
            ) : null
          }
          rightActions={
            showEditButton ? (
              <ActionButton
                label="自己評価編集"
                icon={<EditIcon sx={{ color: PROJECT_COLOR }} />}
                onClick={onEditClick}
                sx={{
                  backgroundColor: PROJECT_COLOR,
                  "&:hover": {
                    backgroundColor: PROJECT_COLOR_DARK,
                  },
                }}
              />
            ) : null
          }
        />
        {/* PCは2列、スマホは1列 */}
        {isEmpty ? (
          <Typography sx={{ color: GRAY_COLOR }}>スキルが未登録です</Typography>
        ) : (
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: isDesktop ? "1fr 1fr" : "1fr",
              gap: 2,
            }}
          >
            {categories.map((category) => (
              <SkillCategory
                key={category.categoryKey}
                category={category}
                owner={owner}
              />
            ))}
          </Box>
        )}
      </Stack>
    </FrameCard>
  );
};

export default SkillSection;
